const mapping: Record<string, string> = {
  id: 'e=>e.Id',
}

export const mapSortEngineMediaActionParam = (key: string) => mapping[key]
